import React from 'react';
import styled from '@emotion/styled';

import AppStoreDownloadButton from '../../../../shared/images/app-store-download-button.svg';
import GooglePlayDownloadButton from '../../../../shared/images/google-play-download-button.svg';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../constants';

const AppDownloadButton = styled('a')`
  display: inline-flex;

  img {
    height: 56px;
    width: auto;
  }
`;

const DownloadButtonsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  @media screen and (max-width: 425px) {
    margin-bottom: 24px;
  }
`;

const AppDownloadButtons = () => (
  <DownloadButtonsContainer>
    <AppDownloadButton href={APP_STORE_URL} target='_blank' rel='noopener noreferrer'>
      <img src={AppStoreDownloadButton} alt='Download on the App Store' />
    </AppDownloadButton>
    <AppDownloadButton href={GOOGLE_PLAY_URL} target='_blank' rel='noopener noreferrer'>
      <img src={GooglePlayDownloadButton} alt='Get it on Google Play' />
    </AppDownloadButton>
  </DownloadButtonsContainer>
);

export default AppDownloadButtons;
